/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 东艺项目详情页自定义标签
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.ProductInfoLabelDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/dongyi/product-info/labels`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
